var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { Color } from '../const/';
import { Horizontal } from '../mixin/mixin';
function Footer(props) {
    var contents = props.contents, sideWidth = props.sideWidth;
    return (React.createElement(PageFooter, { sideWidth: sideWidth },
        React.createElement(Left, null, contents.left),
        React.createElement(Right, null, contents.right)));
}
Footer.defaultProps = {
    sideWidth: 0,
};
var PageFooter = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  border-top: 1px solid ", ";\n  bottom: 0;\n  box-sizing: border-box;\n  justify-content: space-between;\n  left: ", ";\n  padding: 13px 28px 11px;\n  position: fixed;\n  width: ", ";\n  ", ";\n"], ["\n  background: ", ";\n  border-top: 1px solid ", ";\n  bottom: 0;\n  box-sizing: border-box;\n  justify-content: space-between;\n  left: ", ";\n  padding: 13px 28px 11px;\n  position: fixed;\n  width: ",
    ";\n  ", ";\n"])), Color.WHITE, Color.LIGHT_GRAY_2, function (props) { return props.sideWidth + "px"; }, function (props) {
    return props.sideWidth === 0 ? "100%" : "calc(100% - " + props.sideWidth + "px)";
}, Horizontal);
var Left = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var Right = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
export default Footer;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=footer.js.map